import React from 'react';
import SectionsList from '../../../features/sections/SectionsList';

const SummaryPageSections = () => {
    return <SectionsList sectionLocation='registrationSummary' />;
};

export default SummaryPageSections;